import { useContext } from 'react';
import { SidebarContext } from '~/contexts';
import { SidebarContextData } from '~/contexts/SidebarContext/types';

export function useSidebar(): SidebarContextData {
  const context = useContext(SidebarContext);
  return context;
}
